import styled from "styled-components";

import { ReactComponent as ArtFiguresOneSVG } from "../assets/heraldic-people.svg";
import { ReactComponent as ArtFiguresTwoSVG } from "../assets/heraldic-people-pending.svg";

export const LandingSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  > div {
    width: 1150px;

    @media (min-width: 1800px) {
      width: 1300px;
    }
    @media (max-width: 1200px) {
      width: 100%;
      padding: 0 2rem;
    }
  }
`;

export const LandingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > div:first-child {
    display: flex;
    justify-content: space-between;
    margin-bottom: clamp(4.2rem, 8vh, 6rem);
    height: clamp(384px, 50vh, 432px);

    @media (max-width: 1200px) {
      height: 340px;
    }
  }
`;

export const LandingPendingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: clamp(4.2rem, 8vh, 6rem);

  > div:nth-of-type(1) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 60%;
    margin-right: clamp(1.5rem, 2vw, 2.5rem);
    height: auto;

    > div:nth-of-type(1) {
      margin-bottom: 1rem;
    }

    h3 {
      font-size: 1.3rem;
      margin: 0;
      color: ${(props) => props.theme.primaryYellow};
    }

    h1 {
      margin: 0.5rem 0 1.2rem 0;
      font-size: 2.2rem;
      width: 100%;
      white-space: nowrap;

      span {
        color: ${(props) => props.theme.primaryYellow};
      }
    }

    p:nth-of-type(1) {
      margin-bottom: 1.4rem;
      font-size: .9rem;
      width: 100%;

      a {
        color: ${(props) => props.theme.primaryPurple};
        font-weight: 600;
      }
    }
  }
`;

export const LandingText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 70%;
  height: 100%;
  margin-left: clamp(1.5rem, 2vw, 2.5rem);

  > div:nth-of-type(1) {
    h3 {
      font-size: 1.3rem;
      margin: 0;
      color: ${(props) => props.theme.primaryYellow};
    }

    h1 {
      margin: 0.5rem 0 2rem 0;
      font-size: 2.2rem;
      width: 100%;
      white-space: nowrap;

      span {
        color: ${(props) => props.theme.primaryYellow};
      }
    }

    p:nth-of-type(1) {
      margin-bottom: 1rem;
    }
    u {
      color: ${(props) => props.theme.primaryPurple};
      font-weight: bold;
    }
  }

  > div:nth-of-type(2) {
    font-size: 0.7rem;

    p:nth-of-type(1),
    p:nth-of-type(2) {
      margin-bottom: 1rem;
    }
  }
`;

export const LandingStartArt = styled.div`
  width: 100%;

  * {
    display: block;
  }
`;

export const LandingQRContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 1.5rem;
  background-color: ${(props) => props.theme.primaryYellow};
  border-radius: 10px;

  > div {
    box-sizing: border-box;
    padding: 1rem;
    border-radius: 10px;
    width: 100%;
    aspect-ratio: 1/1;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${(props) => props.theme.regWhite};
  }

  h3 {
    text-transform: uppercase;
    margin-top: 0;
    font-weight: 600;
  }
`;

// Art Figures
export const ArtFiguresOne = styled(ArtFiguresOneSVG)`
  width: 100%;
  height: auto;
  display: block;
`;
export const ArtFiguresTwo = styled(ArtFiguresTwoSVG)`
  width: 85%;
  height: auto;
  display: block;
`;
